import { UserMissionTable } from './UserMissionTable'
import { withUserMissionTable } from './withUserMissionTable'

const ConnectedUserMissionTable = withUserMissionTable(UserMissionTable)

export { ConnectedUserMissionTable as UserMissionTable }
